import { createAction } from 'redux-actions'

import * as constants from './constants'

export const fetchBannedIPs = createAction(constants.FETCH_BANNED_IPS)
export const fetchBannedIPsSuccess = createAction(constants.FETCH_BANNED_IPS_SUCCESS)
export const fetchBannedIPsFailed = createAction(constants.FETCH_BANNED_IPS_FAILED)
export const fetchBannedIPsPending = createAction(constants.FETCH_BANNED_IPS_PENDING)

export const banIP = createAction(constants.BAN_IP)
export const banIPSuccess = createAction(constants.BAN_IP_SUCCESS)
export const banIPFailed = createAction(constants.BAN_IP_FAILED)
export const banIPPending = createAction(constants.BAN_IP_PENDING)

export const unbanIP = createAction(constants.UNBAN_IP)
export const unbanIPSuccess = createAction(constants.UNBAN_IP_SUCCESS)
export const unbanIPFailed = createAction(constants.UNBAN_IP_FAILED)
export const unbanIPPending = createAction(constants.UNBAN_IP_PENDING)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/ban/actions.js